import ListVM from './list-vm';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(node) {
    var data = JSON.parse(node.dataset.coursesData);
    var ended_courses_count = node.dataset.endedCoursesCount;

    const vm = new Vue(ListVM);
    vm.initializeBindData(data, ended_courses_count);
    vm.$mount(node);

    // see https://github.com/jonlunsford/share.js for more options
    Kadenze.Share.init();
  }
};
